(function (w, d) {
  'use strict';
  if (w.PH_openaiMeasurement) return;
  var PIXEL_ID = '7zc6pubFKX6jaMZRAJyZoE';
  var PATH = '/pages/custom-golf-towels';
  var initialized = false;
  var pageMeasured = false;
  var sent = Object.create(null);
  var analyticsSent = Object.create(null);
  var analyticsInitialized = false;
  function analyticsLead(id) {
    var p = w.Shopify && w.Shopify.customerPrivacy;
    if (!id || analyticsSent[id] || !p || !p.analyticsProcessingAllowed()) return false;
    w.dataLayer = w.dataLayer || [];
    w.gtag = w.gtag || function () { w.dataLayer.push(arguments); };
    if (!analyticsInitialized) {
      if (!d.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
        var tag = d.createElement('script');
        tag.async = true;
        tag.src = 'https://www.googletagmanager.com/gtag/js?id=G-K1G6ZTWX30';
        d.head.appendChild(tag);
        w.gtag('js', new Date());
      }
      // Inquiry-only configuration: never add another automatic page view.
      w.gtag('config', 'G-K1G6ZTWX30', {send_page_view:false});
      analyticsInitialized = true;
    }
    analyticsSent[id] = true;
    w.gtag('event', 'bulk_order_inquiry', {send_to:'G-K1G6ZTWX30', submission_id:id});
    return true;
  }

  function allowed() {
    try {
      var p = w.Shopify && w.Shopify.customerPrivacy;
      return !!(p && p.marketingAllowed() && p.saleOfDataAllowed());
    } catch (_) { return false; }
  }
  function syncConsent() {
    if (!allowed()) {
      if (initialized) w.oaiq('consent', false);
      return false;
    }
    if (!initialized) {
      if (!w.oaiq) {
        var q = function () { q.q.push(arguments); };
        q.q = [];
        w.oaiq = q;
        var script = d.createElement('script');
        script.async = true;
        script.src = 'https://bzrcdn.openai.com/sdk/oaiq.min.js';
        d.head.appendChild(script);
      }
      w.oaiq('consent', false);
      w.oaiq('init', {pixelId: PIXEL_ID});
      initialized = true;
    }
    w.oaiq('consent', true);
    return true;
  }
  function clickReference() {
    if (!allowed()) return '';
    var param = new URLSearchParams(w.location.search).get('oppref');
    if (param) return param;
    var match = d.cookie.match(/(?:^|;\s*)__oppref=([^;]*)/);
    try { return match ? decodeURIComponent(match[1]) : ''; } catch (_) { return ''; }
  }
  function page() {
    if (w.location.pathname !== PATH || pageMeasured || !syncConsent()) return;
    pageMeasured = true;
    w.oaiq('measure', 'page_viewed', {type:'contents', contents:[{id:'custom-golf-towels'}]});
  }
  w.PH_openaiMeasurement = {
    allowed: allowed,
    analyticsLead: analyticsLead,
    clickReference: clickReference,
    lead: function (id) {
      // Called only after successful non-spam intake acceptance, never on generic form submit.
      if (!id || sent[id] || w.location.pathname !== PATH || !syncConsent()) return false;
      sent[id] = true;
      w.oaiq('measure', 'lead_created', {type:'customer_action'}, {event_id:id});
      return true;
    }
  };
  function ready() {
    if (w.location.pathname !== PATH) return;
    if (w.Shopify && w.Shopify.customerPrivacy) { page(); return; }
    if (w.Shopify && w.Shopify.loadFeatures) {
      w.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], function (error) {
        if (!error) page();
      });
    }
  }
  d.addEventListener('visitorConsentCollected', function () {
    if (w.location.pathname !== PATH) return;
    syncConsent();
    // Prior denied lead events are deliberately not replayed.
    page();
  });
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', ready);
  else ready();
})(window, document);
